<template>
  <v-dialog v-model="internalVisible" max-width="500">
    <v-card>
      <!-- Title Bar -->
      <v-card-title :class="{'body-1':$vuetify.breakpoint.xs}" class="headline">
        <span>Return Lease Confirmation</span>
        <v-btn
            icon
            color="primary"
            class="ml-auto"
            @click="onClose"
            :disabled="submitting"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Lease Count -->
      <v-card-text>
        <v-row>
          <v-col cols="12" class="d-flex justify-center">
            <span class="body-1">Leases Selected: {{ selectedLeases.length }}</span>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider/>

      <!-- Actions -->
      <v-card-actions>
        <v-btn text @click="onClose" :disabled="submitting">Close</v-btn>
        <v-btn
            text
            color="red"
            :loading="submitting"
            :disabled="selectedLeases.length < 1 || submitting"
            @click="onReturnLeases"
        >
          Return Lease(s)
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ReturnLeasesDialog',

  props: {
    visible: {type: Boolean, required: true},
    selectedLeases: {type: Array, required: true},
    onClose: {type: Function, required: true},
    resetForm: {type: Function, required: true}
  },

  data() {
    return {
      internalVisible: this.visible,
      submitting: false,
    }
  },

  methods: {
    onReturnLeases: async function () {
      this.submitting = true;
      try {
        let journalNums = this.selectedLeases.map(item => item.journal_num);

        await this.$axios.patch(`/admin/leases/return`, {journalNums});
        await this.resetForm();
        this.$root.$emit('toast', {type: 'success', message: 'Lease(s) returned successfully'});
        this.internalVisible = false;
      } catch (e) {
        this.$root.$emit('showError', {
          errorMessage: "Failed to return the lease(s).",
          forDevelopers: e
        });
      } finally {
        this.submitting = false;
      }
    },
  },

  watch: {
    visible: function (val) {
      this.internalVisible = val;
    },
    internalVisible: function (val) {
      if (!val) {
        this.onClose();
      }
    }
  },
}
</script>

<style scoped>

</style>